import { PIX_SESSION_TOKEN_REQUEST } from '../../constants/actionTypes';

const INITIAL_STATE = {
  sessionToken: undefined,
};

const applyPixSessionToken = (state, action) => ({
  ...state,
  sessionToken: action.sessionToken,
});

const pixReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PIX_SESSION_TOKEN_REQUEST:
      return applyPixSessionToken(state, action);
    default:
      return state;
  }
};

export default pixReducer;
